import * as actions from './actions';

export default {
  strict: true,
  actions,
  state: {
    isFetchingContentOwnerships: true,
    isFetchingContentOwnership: false,
    allowWebsocketUpdates: true,
  },
  mutations: {
    'contentOwnerships/set': (state, { path, value }) => {
      state[path] = value;
    },
  },
};
